/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentSessionVitals from './treatment-session-vitals';
import TreatmentSessionVitalsDetail from './treatment-session-vitals-detail';
import TreatmentSessionVitalsUpdate from './treatment-session-vitals-update';
import TreatmentSessionVitalsDeleteDialog from './treatment-session-vitals-delete-dialog';

const TreatmentSessionVitalsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentSessionVitals />} />
    <Route path="new" element={<TreatmentSessionVitalsUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentSessionVitalsDetail />} />
      <Route path="edit" element={<TreatmentSessionVitalsUpdate />} />
      <Route path="delete" element={<TreatmentSessionVitalsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentSessionVitalsRoutes;
